﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

@NgComponent({
    token: Token.KbProgress,
    dependencies: [
    ]
})
export class KbProgress extends Directive {
    constructor() {
        super();

        this.restrict = "EA";
        this.replace = true;
        this.scope = {
            animate: "=",
            type: "@",
            value: "@"
        };
        this.template = Dirs.component("kb-progress");

        this.link = (scope, element, atts) => {

        };

    }
}
